// Creates a new action type
const action = str => `$_ACTION_${str.toUpperCase()}_$`;

export default {

  /**
   * The model only got its values updated.
   *
   * @type {string}
   */
  modelUpdated: action('model_updated'),

  /**
   * Indication that a model has been deleted and should close its panel.
   *
   * @type {string}
   */
  modelDeleted: action('model_deleted'),

};



// WEBPACK FOOTER //
// ./resources/assets/js/view-stack/utils/actions.js